import VueNotifications from 'vue-notifications'

export async function request(path, method, okCode, data){
		
	try {
    	const response = await axios({ method: method, url: path, data: data})
		if(response.status == okCode){
			switch(response.status){	
				case 200:
					if(method == 'post'){
			    		VueNotifications.success({ title: 'Operación completada', message: 'Registro actualizado con éxito'})	    
					}
			    	break;

			  	case 201:
			    	VueNotifications.success({ title: 'Operación completada', message: 'Registro almacenado con éxito'})	    
			    	break;
			}
            return response.data
        }	
	}catch(error) {
		switch(error.response.status) {

		  	case 400:
		    	VueNotifications.error({ title: 'Operación rechazada', message: 'Sintaxis incorrecta'})	    
		    	break;

		  	case 401:
		    	VueNotifications.error({ title: 'Operación prohibida', message: 'No tiene los permisos adecuados'})	    
		    	break;

		  	case 500:
		    	VueNotifications.error({ title: 'Error interno', message: 'Ocurrió un error inesperado '})	    
		    	break;

		  	default:
		    // code block
		}
		throw error;
    }
}


export async function parseRequest(path, method, okCode, data){
	try {
    	const response = await axios({ method: method,url: path, data: data})
		if(response.status == okCode){
			switch(response.status){	
				case 200:
					if(method == 'get'){
						if(Array.isArray(response.data)){
			    			response.data.forEach(it =>{
      							Object.keys(it).forEach(k => {
      								if(Array.isArray(it[k])){
      									it[k] = it[k].map(obj => obj.uuid)
      								}else if( (typeof it[k] === "object") && (it[k] !== null) ){
      									if(it[k].value){
      										it[k] = it[k].value
      									}
      									if(it[k].uuid){
      										it[k] = it[k].uuid
      									}
      								} 

      								if(k.includes('_') > 0){
      									it[snakeToCamel(k)] = it[k]
      									delete it[k]
      								} 
      							})
			    			}) 

						}else{
							Object.keys(response.data).forEach(k => {
      								if(Array.isArray(response.data[k])){
      									response.data[k] = response.data[k].map(obj => obj.uuid)
      								}else if( (typeof response.data[k] === "object") && (response.data[k] !== null) ){
      									if(response.data[k].value){
      										response.data[k] = response.data[k].value
      									}
      									if(response.data[k].uuid){
      										response.data[k] = response.data[k].uuid
      									}
      								} 

      								if(k.includes('_') > 0){
      									response.data[snakeToCamel(k)] = response.data[k]
      									delete response.data[k]
      								} 
      						})
						}
					}
			    	break;
			}
            return response.data
        }	
	}catch(error) {
		switch(error.response.status) {

		  	case 400:
		    	VueNotifications.error({ title: 'Operación rechazada', message: 'Sintaxis incorrecta'})	    
		    	break;

		  	case 401:
		    	VueNotifications.error({ title: 'Operación prohibida', message: 'No tiene los permisos adecuados'})	    
		    	break;

		  	default:
		    // code block
		}
		throw error;

		//VueNotifications.error({ message:'sdfs'})
    }
	
}

function snakeToCamel(s){
    return s.replace(/_\w/g, (m) => m[1].toUpperCase() );
}